/**
 * Klartext aus dem Notiz-Sheet → HTML für das Notizfeld (Plan §3d: „Absätze
 * → HTML"). Jede Zeile wird ein Absatz, eine Leerzeile ein leerer Absatz;
 * alles wird maskiert — aus einer Notiz wird nie Markup.
 */
const maskiere = (s: string): string =>
    s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export function textAlsNotizHtml(text: string): string {
    const zeilen = text.replace(/\r\n?/g, "\n").replace(/\s+$/, "").split("\n");
    return zeilen.map((z) => (z.trim() ? `<p>${maskiere(z)}</p>` : "<p><br></p>")).join("");
}
